module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABAAAAAQCAYAAAAf8/9hAAAABmJLR0QA/wD/AP+gvaeTAAAACXBIWXMAAA7EAAAOxAGVKw4bAAAAB3RJTUUH4QQDDB0m0oJ7LAAAAC1JREFUOMtj/P//PwMlgImBQkCxAYwMDAz/h7YXWCj0wSDwwmg0MjAwDv3MBADvCgkWIkUJCwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icons/red_mpa_glp.png
// module id = UjiW
// module chunks = 0